import { CheckIcon, CopyIcon } from 'lucide-react'
import { useState } from 'react'

import { Button, type ButtonProps } from './Button'

interface CopyButtonProps extends ButtonProps {
  text?: string
}

export function CopyButton({ text, ...props }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!text) return

    await navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  const Icon = copied ? CheckIcon : CopyIcon

  return (
    <Button onClick={handleCopy} {...props} isIcon>
      <Icon className="size-4" />
    </Button>
  )
}
